module.exports = {"320922001":"东坎街道","320922002":"坎南街道","320922003":"坎北街道","320922101":"五汛镇","320922102":"蔡桥镇","320922103":"正红镇","320922104":"通榆镇","320922105":"界牌镇","320922106":"八巨镇","320922107":"八滩镇","320922109":"滨淮镇","320922110":"天场镇","320922111":"陈涛镇","320922112":"滨海港镇","320922400":"滨淮农场","320922401":"新滩盐场","320922403":"开发区沿海工业园","320922404":"滨海港经济区","320922405":"滨海县现代农业产业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320922.json
// module id = 1008
// module chunks = 0